import React from 'react';
import { Helmet } from 'react-helmet';

const PageTitle = ({ title }: { title: string }) => {
  return <Helmet title={`Sign In Central Record - ${title}`} />;
};

export default PageTitle;
